export default "__VITE_ASSET__BiSEyJxG__"